import { useState } from "react";

// Holds the API key value and its validity state. The actual validation call
// runs in the composer (which owns the dataSource that depends on this key)
// and writes back via the setters this hook exposes.
export function useApiKey() {
  const [apiKey, setApiKey] = useState("");
  // null = not yet checked, true = available, false = invalid/unavailable
  const [apiKeyValid, setApiKeyValid] = useState<boolean | null>(null);
  const [validating, setValidating] = useState(false);

  return {
    apiKey,
    setApiKey,
    apiKeyValid,
    setApiKeyValid,
    validating,
    setValidating,
  };
}
